// sections/Company.js
import React from 'react';
import './Company.css';
 

const companyInfo = {
  name: '株式会社灯白社',
  founded: '2020年6月1日',
  ceo: '小木曽 一輝',
  address: '〒150-0002 東京都渋谷区渋谷一丁目12番8号',
  phone: '050-3159-6205',
  email: 'contact@tohakusha.co.jp',
  capital: '4,700万円', 
  business: [
    '商品企画、製造、販売',
    '自社EC物販',
    'プロモーション支援',
    'デジタルコンテンツ開発',
    '海外展開・マーケティング支援'
  ],
  clients: [
    '三菱地所',
    '三井不動産',
    '講談社',
    'NetEase Games',
    '株式会社ドン・キホーテ'
  ],
  bank: '三菱UFJ銀行 渋谷支店',
  mapLink: 'https://www.google.co.jp/maps/place/ILA%E6%B8%8B%E8%B0%B7%E7%BE%8E%E7%AB%B9%E3%83%93%E3%83%AB/@35.6605806,139.7016021,17z/data=!3m1!4b1!4m6!3m5!1s0x60188b578b7836e5:0xd30bd1fae0fcda17!8m2!3d35.6605763!4d139.704177!16s%2Fg%2F11y1ybmk41?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoKLDEwMDc5MjA3M0gBUAM%3D'
};

function Company() {
  return (
    <section id="company" className="company-section">
      <h2 className="section-title">COMPANY</h2>
      <div className="company-content">
        <div className="company-info-panel">
          <table>
            <tbody>
              <tr>
                <th>社名</th>
                <td>{companyInfo.name}</td>
              </tr>
              <tr>
                <th>創業</th>
                <td>{companyInfo.founded}</td>
              </tr>
              <tr>
                <th>代表取締役</th>
                <td>{companyInfo.ceo}</td>
              </tr>
              <tr>
                <th>所在地</th>
                <td>
                  <p>{companyInfo.address}</p>
                  <a
                    href={companyInfo.mapLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="location-button"
                  >
                    LOCATION
                  </a>
                </td>
              </tr>
              <tr>
                <th>電話番号</th>
                <td>
                  <a href={`tel:${companyInfo.phone}`}>{companyInfo.phone}</a>
                </td>
              </tr>
              <tr>
                <th>メールアドレス</th>
                <td>
                  <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
                </td>
              </tr>
              <tr>
                <th>事業内容</th>
                <td>
                  <ul>
                    {companyInfo.business.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </td>
              </tr>
              <tr>
                <th>主要取引先</th>
                <td>
                  <ul>
                    {companyInfo.clients.map((client, index) => (
                      <li key={index}>{client}</li>
                    ))}
                  </ul>
                </td>
              </tr>
              <tr>
                <th>取引先銀行</th>
                <td>{companyInfo.bank}</td>
              </tr>
              <tr>
                <th>資本金</th>
                <td>{companyInfo.capital}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="company-map-panel">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.6669546469016!2d139.704177!3d35.660576299999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188b578b7836e5%3A0xd30bd1fae0fcda17!2zSUxB5riL6LC3576O56u544OT44Or!5e0!3m2!1sja!2sjp!4v1766027432950!5m2!1sja!2sjp"
            width="520"
            height="520"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="会社所在地地図"
          />
        </div>
      </div>
    </section>
  );
}

export default Company;
